/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MehrarbeitUmbuchungDto } from '../../models/mehrarbeit-umbuchung-dto';

export interface GetAllMehrarbeitUmbuchungen$Json$Params {
  date?: string;
  mitarbeiterId?: string;
}

export function getAllMehrarbeitUmbuchungen$Json(http: HttpClient, rootUrl: string, params?: GetAllMehrarbeitUmbuchungen$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MehrarbeitUmbuchungDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllMehrarbeitUmbuchungen$Json.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MehrarbeitUmbuchungDto>>;
    })
  );
}

getAllMehrarbeitUmbuchungen$Json.PATH = '/v1/mehrarbeitumbuchung';
